import type { Scope } from '#packages/sections';
import { fixSingleSectionOverheight } from './fixSingleSectionOverheight';
import { removeSectionsGaps } from './removeSectionsGaps';
import { enforceSectionAnchorInfo } from './enforceSectionAnchorInfo';
import { ErrorReporter } from '@wix/editor-error-reporter';

export const enforceSectionsLayoutOnHomepage = async (scope: Scope) => {
  const { editorAPI } = scope;
  const pageRef = editorAPI.pages.getCurrentPage();

  try {
    await enforceSectionAnchorInfo(scope, pageRef);
    const isLayoutUpdated = await fixSingleSectionOverheight(
      scope,
      pageRef,
      true,
    );
    if (isLayoutUpdated) {
      await removeSectionsGaps(scope, pageRef);
    }
  } catch (error: MaybeError) {
    error.name = `[SectionsOnBootstrapEnforcement]: ${error.name}`;
    ErrorReporter.captureException(error);
  }
};
